import React from "react";
import { siteConfig } from "../siteConfig";
import TrustBar from "../components/TrustBar";
import Reveal from "../components/Reveal";

const AboutPage = () => (
  <>
    {/* Page Hero */}
    <section className="pt-32 pb-16" style={{ backgroundColor: siteConfig.colors.dark }}>
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <div className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: siteConfig.colors.primary }}>About Us</div>
        <h1 className="font-display font-black text-white leading-tight" style={{ fontSize: "clamp(2rem,5vw,3.5rem)" }}>
          {siteConfig.about.headline}
        </h1>
      </div>
    </section>

    <TrustBar />

    {/* Story */}
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-5 md:px-8 grid md:grid-cols-2 gap-12 items-center">
        <Reveal as="div" animation="right" className="rounded-2xl overflow-hidden aspect-[4/3] shadow-lg">
          <img src={siteConfig.about.image} alt="Our team" className="w-full h-full object-cover" />
        </Reveal>
        <Reveal as="div">
          <div className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: siteConfig.colors.primary }}>Our Story</div>
          <h2 className="font-display font-black leading-tight mb-5" style={{ fontSize: "clamp(1.5rem,3vw,2.25rem)", color: siteConfig.colors.dark }}>
            Founded in {siteConfig.about.founded}. Built on quality.
          </h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            {siteConfig.about.body}
          </p>
          <p className="text-gray-600 leading-relaxed">
            Every project we take on reflects our commitment to craftsmanship, communication, and doing things the right way the first time. We're proud to serve the {siteConfig.city}, {siteConfig.state} community and the surrounding areas.
          </p>
        </Reveal>
      </div>
    </section>

    {/* Stats */}
    <section className="py-16" style={{ backgroundColor: siteConfig.colors.light }}>
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-3 gap-6 text-center">
          {[
            { value: siteConfig.about.yearsExperience, label: "Years in Business" },
            { value: siteConfig.about.projectsCompleted, label: "Projects Completed" },
            { value: "100%", label: "Satisfaction Goal" },
          ].map((s, i) => (
            <Reveal key={s.label} delay={i * 100}>
              <div className="font-display font-black text-4xl md:text-5xl mb-2" style={{ color: siteConfig.colors.primary }}>{s.value}</div>
              <div className="text-gray-600 text-sm font-medium">{s.label}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

  </>
);

export default AboutPage;
